import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthInput } from './auth-input.model';

@Component({
  selector: 'lib-auth-form',
  templateUrl: './auth-form.component.html',
  styleUrls: ['./auth-form.component.scss']
})
export class AuthFormComponent implements OnInit {
  authForm: FormGroup;
  @Input() items: AuthInput[];
  @Input() formClass: string;
  @Input() errorMessage: string;
  @Input() isErrorHidden: boolean;
  @Input() submitHandler(form: FormGroup): void {
  }

  ngOnInit() {
    this.items.map((item) => new AuthInput(item));
    this.authForm = new FormGroup({
      ...this.getProperties(),
    });
  }

  getProperties() {
    return this.items.reduce((obj, item) => {
      obj[item.name] = new FormControl('', [
        item.required
          ? Validators.minLength(item.minlength)
          : null,
        item.required ? this.findInvalidCharacters.bind(this, item.validationExp) : null,
        item.required ? Validators.required : null,
      ]);

      return obj;
    }, {});
  }

  findInvalidCharacters(validationExp: any, control: FormControl) {
    if (control.value.search(validationExp) === -1) {
      return { isInvalidSymbols: true };
    }

    return null;
  }

  onSubmit() {
    this.submitHandler(this.authForm);
  }

  hideError() {
    this.isErrorHidden = true;
  }
}
